// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import {LMModel} from '@form/model';
import { LMFormLayoutService } from '@form/services';

enum LMElementLayoutType {
  FIELD = 0,
  CHECK_CONTROL,
  HEADER,
  PARAGRAPH,
  BUTTON,
  BLANK,
  TEXT,
  MENU,
  MANUAL_REPRESENTATION
}

@Component({
  selector:    'lm-element',
  standalone: false,
  templateUrl: './lm-element-layout.component.html',
  styleUrls:   [ './lm-element-layout.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMElementLayoutComponent implements OnInit, OnChanges {
  @Input() layoutObject: LMFormLayoutElements;
  @Input() specFields: LMSpecFields;
  @Input() placeHolder: ViewContainerRef;
  @Input() model: LMModel;
  @Input() layoutInfo: LMFormLayoutInfo;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  public elements: Array<LMFormLayoutElement>;
  layoutType;

  constructor(
      private lmFormLayoutService: LMFormLayoutService
  ) {
    this.layoutType = LMElementLayoutType;
  }

  ngOnInit() {
    this.initialize();
  }

  // onChanges required for ad hoc search
  ngOnChanges(changes: SimpleChanges) {
    if (this.layoutInfo?.isAdHoc && changes.layoutObject) {
      this.initialize();
    }
  }

  private initialize(){
    this.elements = this.layoutObject.elements;

    if (this.elements === undefined) {
      return;
    }

    this.elements.forEach((element: LMFormLayoutElement, i) => {
      element.index = i;
      if (element.field) {
        element.elementLayout = this.layoutType.FIELD;
        element.id = element.field.bindId;

      } else if (element.checkcontrol) {
        element.elementLayout = this.layoutType.CHECK_CONTROL;
        element.id = element.checkcontrol.bindId;

      } else if (element.header) {
        element.elementLayout = this.layoutType.HEADER;
        element.id = element.header.bindId;

      } else if (element.paragraph) {
        element.elementLayout = this.layoutType.PARAGRAPH;
        element.id = 'paragraph_' + Date.now();

      } else if (element.button) {
        element.elementLayout = this.layoutType.BUTTON;
        element.id = element.button.bindId;

      } else if (element.Blank) {
        element.elementLayout = this.layoutType.BLANK;
        element.id = 'blank_' + Date.now();

      } else if (element.text) {
        element.elementLayout = this.layoutType.TEXT;
        element.id = 'text_' + Date.now();

      } else if (element.menu) {
        element.elementLayout = this.layoutType.MENU;
        element.id = element.menu.menuSecurityId;

      } else if (element.manualrep) {
        element.elementLayout = this.layoutType.MANUAL_REPRESENTATION;
        element.id = element.manualrep.fieldId;

      } else if (element.captchaControl) {
        element.elementLayout = this.layoutType.CAPTCHA_CONTROL;
        element.id = element.captchaControl.bindId;
      }
    });

    this.lmFormLayoutService.calculatePreviousHeaderSiblings(this.elements, 2);
  }

  public onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }

  public trackByIndex(index: number, element: LMFormLayoutElement): string {
    return element.field.bindId;
  }
}
